/**
 * Configuración del emisor para facturación de tareas especiales.
 *
 * Estado actual: emisor único = TAXTIC CURICÓ (RUT 76.469.207-1).
 * Multiempresa preparado pero deshabilitado — activar
 * `APP_CONFIG.EMISOR.MULTIEMPRESA_HABILITADO = true` cuando cada
 * sucursal tenga su propia API key Haulmer configurada en
 * `sucursal.apiOpenFactura` y `sucursal.rutRazonSocial` validado contra el SII.
 */

import { APP_CONFIG } from "src/config/appConfig";

/**
 * Retorna el RUT que debe usarse como emisor del DTE para la sucursal actual.
 * Hoy siempre retorna el RUT por defecto. Cuando se active multiempresa,
 * retorna `sucursal.rutRazonSocial` si está disponible.
 *
 * @param {Object} sucursal - objeto sucursal del Redux state (`state.auth.user.sucursal`)
 * @returns {string} RUT emisor sin puntos, con guion (formato "76469207-1")
 */
export const obtenerRutEmisor = (sucursal) => {
  if (APP_CONFIG.EMISOR.MULTIEMPRESA_HABILITADO && sucursal?.rutRazonSocial) {
    return sucursal.rutRazonSocial;
  }
  return APP_CONFIG.EMISOR.RUT_EMISOR_DEFAULT;
};

/**
 * Fallback del emisor — datos de TAXTIC CURICÓ y respuesta
 * real Haulmer para 76469207-1. Se usa en el preview HTML cuando
 * la consulta SII falla por rate limit, timeout u otra razón.
 *
 */
export const DATOS_EMISOR_FALLBACK = {
  rut: "76469207-1",
  razonSocial:
    "TAXTIC, CONTADORES Y AUDITORES PROFESIONALES ASOCIADOS LIMITADA",
  telefono: "752221800",
  direccion: "CARMEN 459",
  comuna: "Curicó",
  giro: "SERVICIOS DE ASESORÍAS Y CONSULTORÍA CONTABLE Y TRIBUTARIA",
  actividadEconomica: "OTRAS ACTIVIDADES DE SERVICIOS PERSONALES N.C.P.",
  sucursalSIICiudad: "Curicó",
};
